<template>
  <div data-v-3e52ce59="" class="loading">
    <div data-v-3e52ce59="" class="loader"><span class="k8-loader"></span></div>
  </div>
</template>

<script>
export default {
  name: 'gamePage',
  data() {
    return {};
  },
  components: {},
  created() {
    let that = this;
    var query = that.$route.query;
    console.log(query);
    if (query.dailiD) {
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          window.open(res.data.url, '_self');
        }
      });
      return;
    }
    if (query.name) {
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  mounted() {},
  methods: {
    goGamePage(name, type, code) {

      let that = this;
      type = type || 0 ;
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type, game_code: code, is_mobile_url: 0 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
            setTimeout(() => {
              window.location.href = 'about:blank';
              window.close();
            }, 2000);
          }
          if (res.code == 200) {
            window.open(res.data.url, '_self');
          }
        })
        .catch(res => {
          setTimeout(() => {
            window.location.href = 'about:blank';
            window.close();
          }, 2000);
        });
    },
    showTost(type, title) {
      // error  success
      let str = type ? 'success' : 'error';
      $('body').append(`
            <div role="alert" class="ants-message el-message el-message--${str}" style="top: 20px; z-index: 2009;"><i class="el-message__icon el-icon-${str}"></i>
            <p class="el-message__content">${title}
            </p></div>`);
      setTimeout('$(".ants-message").detach()', 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/gamePage.vue